/**
 * Copyright (c) 2019 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Injectable} from "@angular/core";

import * as statistics from 'simple-statistics'

import {ShotScore} from "../../../../dualuse/aig/modules/score/score";

/**
 * todo
 */
@Injectable({
	providedIn: "root",
})

export class ShotScoreService extends ShotScore {

	constructor() {
		super();
		this.statistics = statistics;
	}

}
